import {BreadcrumbType} from 'platform/components';

import {useListInterestAssignmentConditionsQuery} from '@dms/api/core';
import {i18n} from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {useNavigate} from 'shared/web';

import {AssignmentConditionList} from './components/AssignmentConditionList';

const breadcrumbs: BreadcrumbType[] = [
  {
    label: i18n.t('entity.interest.labels.interest'),
    href: settingsRoutes.interest,
  },
];

export function SalesLeadsAssignment() {
  const navigate = useNavigate();

  const {
    data: conditions,
    isLoading,
    isError,
  } = useListInterestAssignmentConditionsQuery({teamId: null});

  return (
    <SettingsTemplate
      header={{
        title: i18n.t('entity.interest.labels.SalesLeadsAssignment'),
        breadcrumbs,
        actions: [
          {
            type: 'button',
            title: i18n.t('entity.interest.labels.newCondition'),
            onClick: () => navigate(settingsRoutes.salesLeadsAssignmentNew),
            'data-testid': testIds.settings.salesLeadsAssignment('newConditionButton'),
          },
        ],
      }}
      data-testid="settings-sales-leads-assignment"
      isLoading={isLoading}
      isError={isError}
    >
      <AssignmentConditionList
        conditions={conditions ?? []}
        data-testid={testIds.settings.salesLeadsAssignment('conditionList')}
      />
    </SettingsTemplate>
  );
}
